<template>
  <div class="has-text-centered">
    <p class="has-text-left">
      {{ $wording.resetpw.error_2 }}
      <router-link :to="{ name: 'reset-password-init' }">
        Visit reset password.
      </router-link>
    </p>
    <p class="has-text-centered">
      <router-link :to="{ name: 'login' }">
        Log in to your account
      </router-link>
    </p>
  </div>
</template>

<script>
export default {
};
</script>